module.exports = __webpack_public_path__ + "8c95f9fbc00552ed8cc24e260335e658.svg";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/adelle_bold-webfont.svg
// module id = 75
// module chunks = 0